import React from 'react';
export function BeforeAfterSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-white to-baby-cream" data-id="element-260">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-261">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-262">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-263">
            La Transformación Real
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-264">
            De la improvisación y el estrés... a la confianza y la tranquilidad
          </p>
        </div>

        <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-265">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/egw4Qy3eehZvS2oBmcJtf1/2-marketing_image.png" alt="Antes vs Después - De improvisar cada día a tener 30 recetas listas" className="w-full h-auto" data-id="element-266" />
        </div>

        <div className="mt-8 sm:mt-12 grid md:grid-cols-2 gap-6 sm:gap-8 stagger-children" data-id="element-267">
          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-gray-200 shadow-baby-soft" data-id="element-268">
            <div className="flex items-center gap-3 mb-4" data-id="element-269">
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-270">
                <span className="text-xl" data-id="element-271">😰</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-272">
                Antes
              </h3>
            </div>
            <ul className="space-y-3 text-sm sm:text-base text-gray-700" data-id="element-273">
              <li className="flex items-start gap-2" data-id="element-274">
                <span className="text-gray-400 mt-1" data-id="element-275">•</span>
                <span data-id="element-276">Improvisando cada día sin plan</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-277">
                <span className="text-gray-400 mt-1" data-id="element-278">•</span>
                <span data-id="element-279">Estrés y culpa constante</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-280">
                <span className="text-gray-400 mt-1" data-id="element-281">•</span>
                <span data-id="element-282">Miedo a las texturas</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-283">
                <span className="text-gray-400 mt-1" data-id="element-284">•</span>
                <span data-id="element-285">Dudas todo el tiempo</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 sm:p-8 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-286">
            <div className="flex items-center gap-3 mb-4" data-id="element-287">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center" data-id="element-288">
                <span className="text-xl" data-id="element-289">😊</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-290">
                Después
              </h3>
            </div>
            <ul className="space-y-3 text-sm sm:text-base text-gray-800" data-id="element-291">
              <li className="flex items-start gap-2" data-id="element-292">
                <span className="text-baby-blue mt-1" data-id="element-293">✓</span>
                <span className="font-medium" data-id="element-294">
                  30 recetas listas y organizadas
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-295">
                <span className="text-baby-pink mt-1" data-id="element-296">✓</span>
                <span className="font-medium" data-id="element-297">Confianza y tranquilidad</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-298">
                <span className="text-baby-blue mt-1" data-id="element-299">✓</span>
                <span className="font-medium" data-id="element-300">Texturas seguras y claras</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-301">
                <span className="text-baby-pink mt-1" data-id="element-302">✓</span>
                <span className="font-medium" data-id="element-303">Sabes exactamente qué hacer</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}